import React from "react";

import { Section } from "@/types/common";

import { SectionRenderer } from "./SectionRenderer";

export const TwoColumnLayout = ({ data, hideBrandLogo }: { data: Section, hideBrandLogo?: boolean }) => {
  
  if (!data.sections || data.sections.length === 0) {
    return null;
  }

  const leftSection = data.sections[0];
  const rightSection = data.sections[1];
  


  return (
    <section className="max-w-7xl mx-auto px-4 w-full sm:px-6 lg:px-8 xl:px-0 scroll-mt-[100px] scroll-smooth" data-template={data.template}>
      <div className="flex lg:flex-row flex-col gap-8 w-full relative">
        <div className="lg:w-[70%] w-full">
          <div className="space-y-6">
            {leftSection?.sections && leftSection.sections.length > 0 ? (
              <SectionRenderer sectionsData={[data.sections[0]]} hideBrandLogo={hideBrandLogo} />
            ) : (
              <div></div>
            )}
          </div>
        </div>
        <div className="lg:w-[30%] w-full">
          <div className="space-y-6 sticky top-24">
            {rightSection?.sections && rightSection.sections.length > 0 ? (
              <SectionRenderer sectionsData={[data.sections[1]]} hideBrandLogo={hideBrandLogo} />
            ) : (
              <div></div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
